import React from "react";
import { CareRecipient } from "../../../../domain/care_recipient/CareRecipient";
import { SubButton } from "../../common/button/SubButton";
import { CareRecipientIcon } from "../../common/icons/CareRecipientIcon";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../state/store";
import { selectCareRecipientAction } from "../../../../state/usecase/care_recipient/actions";

export const CareRecipientInfo = React.memo(function CareRecipientInfo(props: Props) {
    const { careRecipient } = props;

    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const onClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        dispatch(selectCareRecipientAction(careRecipient));
        navigate(`/care_recipient/config/${careRecipient.id.value}`);
    };
 
    return (
        <div className={"care_recipient_info"}>
            <div className={"care_recipient_info__info"}>
                <div className={"name"}>
                    <div className={"name__image"}>
                        <CareRecipientIcon careRecipientId={careRecipient.id}/>
                    </div>
                    <div className={"name__name"}>
                        <p className={"value"}>
                            {careRecipient.name.value}
                        </p>
                    </div>
                </div>
            </div>
            <div className={"care_recipient_info__end"}>
                <div className={"configuration"}>
                    <div className={"button_area"}>
                        <SubButton onClick={onClick}>設定</SubButton>
                    </div>
                </div>
            </div>
        </div>
    );
});

type Props = {
    careRecipient: CareRecipient
};
